import React, { useMemo, useState } from "react";
import {
	CustomButton,
	CustomIconButton,
	CustomTable,
	CustomTableBody,
	CustomTableCell,
	CustomTableHead,
	CustomTableRow,
	icon,
} from "../../../../../../common/components";
import styles from "./DSICompanyTable.module.css";
import { translate } from "../../../../../../common/providers";
import { DSICompanyBuCreationDialog } from "..";

function getCompanyHasChildren(data) {
	const result = [];
	for (const item of data) {
		if (item.children && item.children.length > 0) {
			result.push(item.id);
			result.push(...getCompanyHasChildren(item.children));
		}
	}
	return result;
}

export default function DSICompanyTable({
	activeUsersInCompany,
	companies,
	selectedCompany,
	onCreateBu,
	onSelectCompany,
	onSelectRow,
}) {
	const [expandedRows, setExpandedRows] = useState(getCompanyHasChildren(companies));
	const [openCreationDialog, setOpenCreationDialog] = useState(false);
	const [parent, setParent] = useState(null);
	const headers = useMemo(() => [translate("dsi.dsi-company.th.name"), translate("dsi.dsi-company.th.type"), ""], []);
	const toggleRowExpansion = (companyId, force) => {
		if (expandedRows.includes(companyId) && !force) {
			setExpandedRows(expandedRows.filter((id) => id !== companyId));
		} else {
			setExpandedRows([...expandedRows, companyId]);
		}
	};
	const handleRowClick = (company) => {
		onSelectRow(company);
	};
	const handleExpand = (e, company) => {
		e?.stopPropagation();
		if (company.children || company.force) {
			toggleRowExpansion(company.id, company.force);
		}
	};
	const handleCreateBu = (name, parentId, adminId) => {
		onCreateBu(name, parentId, adminId);
		handleExpand(null, { id: parentId, force: true });
	};
	const handleOpenCreationDialog = (e, company) => {
		e.stopPropagation();
		setOpenCreationDialog(true);
		setParent(company);
		onSelectCompany(company);
	};
	const handleCloseCreationDialog = () => {
		setOpenCreationDialog(false);
		setParent(null);
	};
	const renderCompanyRows = (company, level = 0) => (
		<React.Fragment key={company.id}>
			<CustomTableRow
				hover
				className={selectedCompany === company ? styles["tableRow--selected"] : styles.tableRow}
				onClick={() => handleRowClick(company)}
			>
				<CustomTableCell style={{ paddingLeft: `${16 + level * 32}px` }}>
					{company.children && (
						<CustomIconButton
							className={styles.expandBtn}
							icon={expandedRows.includes(company.id) ? icon.faChevronDown : icon.faChevronRight}
							translate="no"
							onClick={(e) => handleExpand(e, company)}
						/>
					)}
					<span className={company?.children ? styles.parentName : styles.childName}>
						{company.companyName}
					</span>
				</CustomTableCell>
				<CustomTableCell>{company.type}</CustomTableCell>
				<CustomTableCell>
					{company.type !== "CONSORTIUM" && (
						<CustomButton
							size="sm"
							startIcon={icon.faPlus}
							variant="contained"
							onClick={(e) => handleOpenCreationDialog(e, company)}
						>
							{translate("dsi.dsi-company.bu.create")}
						</CustomButton>
					)}
				</CustomTableCell>
			</CustomTableRow>
			{Array.isArray(company.children) &&
				expandedRows.includes(company.id) &&
				company.children.map((childCompany) => renderCompanyRows(childCompany, level + 1))}
		</React.Fragment>
	);

	return (
		<>
			<CustomTable>
				<CustomTableHead>
					<CustomTableRow>
						{headers.map((header) => (
							<CustomTableCell key={header} className={styles.cell}>
								{header}
							</CustomTableCell>
						))}
					</CustomTableRow>
				</CustomTableHead>
				<CustomTableBody>
					{Array.isArray(companies) && companies.map((company) => renderCompanyRows(company))}
				</CustomTableBody>
			</CustomTable>
			<DSICompanyBuCreationDialog
				activeUsersInCompany={activeUsersInCompany}
				open={openCreationDialog}
				parent={parent}
				onClose={handleCloseCreationDialog}
				onCreate={handleCreateBu}
			/>
		</>
	);
}
